<template>
  <div class="inner-tab-wrapper mb-4">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div
          class="policies-top-actions d-flex justify-content-end mt-2 mb-3"
          style="gap: 10px"
        >
          <!-- se la polizza è manuale e lo stato della polizza è perfezionata (1) oppure sospesa (2), compare il tasto "modifica" -->
          <b-button
            class="btn btn--create btn--smaller"
            type="button"
            variant="lisaweb"
            size="sm"
            @click="onModifica"
            title="Modifica"
            v-if="
              canVerb('insurance_policies', 'edit') &&
              !isImported &&
              [1, 2].includes(statusPolicyValue)
            "
          >Modifica
          </b-button
          >
          <!-- se la polizza è manuale e lo stato della polizza è perfezionata (1) oppure sospesa (2), compare il tasto "sostituisci" -->
          <b-button
            class="btn btn--create btn--smaller"
            type="button"
            variant="lisaweb"
            size="sm"
            @click="onSostituisci"
            title="Sostituisci"
            v-if="
              canVerb('insurance_policies', 'store') &&
              !isImported &&
              [1, 2].includes(statusPolicyValue)
            "
          >Sostituisci
          </b-button
          >
          <!-- se la polizza è manuale e lo stato della polizza è perfezionata (1) oppure sospesa (2), compare il tasto "voltura" -->
          <b-button
            class="btn btn--create btn--smaller"
            type="button"
            variant="lisaweb"
            size="sm"
            @click="onVoltura"
            title="Voltura"
            v-if="
              canVerb('insurance_policies', 'edit') &&
              !isImported &&
              [1, 2].includes(statusPolicyValue)
            "
          >Voltura
          </b-button
          >
        </div>
        <div data-type="policy-general">
          <details-card
            v-for="(item, index) in dtlFlds1"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :shortcut="item.shortcut"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @modal="onOpenDetailsModal"
          >
          </details-card>
          <b-card
            header="true"
            header-tag="header"
            class="mt-2"
            v-if="coassDetails.length"
          >
            <div
              slot="header"
              class="d-flex justify-content-between align-items-center"
            >
              <p class="mb-0 d-inline-block align-middle">
                <b>Coassicurazioni</b>
              </p>
            </div>
            <b-card-text>
              <p>
                <b>Nostra quota per coass delega Nostra:</b>
                {{ details.sharing }}%
              </p>
              <b-table
                striped
                hover
                :items="coassDetails"
                :fields="coassDetailFields"
              >
                <!-- compagnia_delegata: code_importer - title_importer
                agenzie_delegate: code
                quote_attribuite: pivot.share -->
                <template v-slot:cell(compagnia_delegata)="row">
                  {{ row.item.code_importer }} - {{ row.item.title_importer }}
                </template>
                <template v-slot:cell(agenzie_delegate)="row">
                  {{ row.item.code }}
                </template>
                <template v-slot:cell(quote_attribuite)="row">
                  {{ row.item.pivot.share }}%
                </template>
              </b-table>
            </b-card-text>
          </b-card>
          <details-card
            v-for="(item, index) in dtlFlds2"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :shortcut="item.shortcut"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
            @modal="onOpenDetailsModal"
          >
          </details-card>
          <details-card
            v-for="(item, index) in detailFields"
            :key="index"
            :title="index"
            :header="item.header"
            :edit="item.edit || false"
            :fields="item.fields"
            :beForm="beForm"
            :data="details"
            :repository="item.repository"
          >
            <!-- :labels="labels" -->
          </details-card>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <!-- <base-icon name="loading" width="35" height="35" /> -->
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
      <!-- :number="modalNumber" -->
      <!-- <details-modal
        v-if="!isLoading"
        :resourceId="modalResourceId"
        @modal="onOpenDetailsModal"
        :name="`detailsModal${modalResourceId}`"
      /> -->
      <b-modal
        id="modal"
        @modal="onOpenDetailsModal"
        @show="onModalShow"
        @hidden="onModalHidden"
        :title="computeModalTitle"
        size="xl"
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14" />
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  :dbRowData="dbRowData"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </b-overlay>
  </div>
</template>

<script>
import ShowMixin from "@/mixins/ShowMixin";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import DetailsCard from "@/components/DetailsCard";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/wallet/policies/details/General";
import TechnicalData from "@/components/wallet/policies/details/TechnicalData";
import Registry from "@/components/wallet/policies/details/Registry";
import Group from "@/components/wallet/policies/details/Group";
import Titles from "@/components/wallet/policies/details/Titles";
import Accident from "@/components/wallet/policies/details/Claims";
import Notes from "@/components/wallet/policies/details/Notes";
import Todo from "@/components/wallet/policies/details/Todo";
import Accounting from "@/components/wallet/policies/details/Accounting";
import Appointments from "@/components/wallet/policies/details/Appointments";
import Documents from "@/components/wallet/policies/details/Documents";
import Sepa from "@/components/wallet/policies/details/Sepa";
import {toInfoData} from "@/utils/transforms";
import {getRiskTypeDescription} from "@/utils/payments";
import {canVerb} from "@/utils/permissions";
import BaseIcon from "@/components/BaseIcon";
import {mapGetters} from "vuex";

export default {
  name: "General",
  mixins: [FormMixin, ShowMixin, ShortcutMixin],
  props: {
    resourceId: Number,
  },
  components: {
    DetailsCard,
    BaseIcon,
    ButtonGroupTab,
    General,
    TechnicalData,
    Registry,
    Group,
    Titles,
    Accident,
    Notes,
    Accounting,
    Documents,
    Appointments,
    Todo,
    Sepa,
    // DetailsModal: () => import("@/components/modals/showDetailsModal"),
  },
  data() {
    return {
      details: null,
      modalResourceId: null,
      modalResourceTitle: null,
      isImported: true,
      statusPolicyValue: null,
      fetchedDetails: null,
      selected: "General",
      tabIndex: 0,
      dbRowData: null,
      tabs: [
        {name: "General", text: "Generale"},
        {name: "TechnicalData", text: "Dati tec."},
        {name: "Registry", text: "Contraente"},
        {name: "Titles", text: "Titoli"},
        {name: "Accounting", text: "Incassi"},
        {name: "Accident", text: "Sinistri"},
        {name: "Appointments", text: "Appuntamenti"},
        {name: "Notes", text: "Note"},
        {name: "Todo", text: "Attività"},
        {name: "Group", text: "Gruppi"},
        {name: "Documents", text: "Doc"},
        {name: "Sepa", text: "Sepa"},
      ],
      // modalNumber: null,
      repositoryResourceId: {
        correspondence: {
          id: null,
        },
        registry: {
          id: null,
        },
      },
      status_registry_value: 0,
      // status_coass: false,
      repository: "insurance_policy",
      isLoading: true,
      // splittato detailFields in 2 oggetti distinti detailFields1 e detailFields2:
      // per inserire nel mezzo la table "statica" coassDetails...
      detailFields: {},
      detailFields1: {
        // campi in comune
        dati_identificativi: {
          header: "Dati identificativi",
          edit: false,
          // replace: false,
          // shortcut_replace: {},
          shortcut: {},
          repository: "insurance_policy",
          fields: [
            {
              label: "Compagnia",
              value: "insurer.code",
              virtual: (detail) => {
                return `${detail.insurer.code} - ${detail.insurer.title}`;
              },
            },
            {
              label: this.getDictionary("number", "insurance_policy"),
              value: "number",
            },
            {
              label: this.getDictionary("code", "risk_branch"), // "risk_branch.default" la label di questa sotto-relazione non arriva nel beForm di repository: uso il default
              value: "insurance_risk.risk_branch.code",
            },
            {
              label: "Descrizione Ramo", // "insurance_risk.default" la label di questa sotto-relazione non arriva nel beForm di repository: uso il default
              value: "insurance_risk.risk_branch.title",
            },
            {
              label: "Codice Prodotto", // "risk_type.default" la label di questa sotto-relazione non arriva nel beForm di repository: uso il default
              value: "insurance_risk.code",
            },
            {
              label: "Descrizione Prodotto", // "insurance_risk.default" la label di questa sotto-relazione non arriva nel beForm di repository: uso il default
              value: "",
              virtual: (detail) => {
                return this.getRiskTypeDescription(detail);
              },
            },
            {
              label: this.getDictionary("mandate_code", "insurance_policy"),
              value: "",
              virtual: (detail) => {
                return (
                  this.getMandateCodes()().find(
                    (m) => m.value === detail.mandate_code_id,
                  )?.code ?? detail.mandate_code_id
                );
              },
            },
            {
              label: this.getDictionary("salesman"),
              value: "broker",
              virtual: (detail) => this.evaluateBroker(detail),
            },
            {
              label: this.getDictionary("Collaborazione orizzontale"),
              // label: this.getDictionary("Polizza in collaborazione"),
              value: "collaborator",
              virtual: (detail) => {
                return detail.collaborator
                  ? this.toInfoData(detail.collaborator, "broker", 1)
                  : "";
              },
            },
          ],
        },
        premi: {
          header: "Premi",
          edit: false,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary("net_premium", "insurance_policy"),
              value: "net_premium",
              type: "currency",
            },
            {
              label: this.getDictionary("tax_premium", "insurance_policy"),
              value: "tax_premium",
              type: "currency",
            },
            {
              label: this.getDictionary("gross_premium", "insurance_policy"),
              value: "gross_premium",
              type: "currency",
            },
          ],
        },
        dati: {
          header: "Dati",
          edit: false,
          repository: "insurance_policy",
          fields: [
            {
              label: this.getDictionary(
                "payment_splitting",
                "insurance_policy"
              ),
              value: "payment_splitting.text",
            },
            {
              label: this.getDictionary("issued_at"),
              value: "issued_at",
              type: "datepicker",
            },
            {
              label: this.getDictionary("effective_at"),
              value: "effective_at",
              type: "datepicker",
            },
            {
              label: this.getDictionary("expired_at"),
              value: "expired_at",
              type: "datepicker",
            },
            {
              label: this.getDictionary("covered_at"),
              value: "covered_at",
              type: "datepicker",
            },
            {
              label: this.getDictionary("suspended_at", "insurance_policy"),
              value: "suspended_at",
              type: "datepicker",
            },
            {
              label: this.getDictionary(
                "attribute_REVD_value",
                "insurance_policy"
              ),
              value: "attributables.REVD",
            },
            {
              label: this.getDictionary(
                "attribute_RENW_value",
                "insurance_policy"
              ),
              value: "attributables.RENW",
              /* Commented out since all the Y/N values are not formatted on the FE
              virtual: (detail) => {
                return Object.prototype.hasOwnProperty.call(
                  detail,
                  "attributables"
                ) &&
                  Object.prototype.hasOwnProperty.call(
                    detail.attributables,
                    "RENW"
                  )
                  ? detail.attributables.RENW === "Y"
                    ? "Sì"
                    : detail.attributables.RENW === "N"
                    ? "No"
                    : "-"
                  : "-";
              },
              */
            },
            {
              label: this.getDictionary(
                "attribute_INDX_value",
                "insurance_policy"
              ),
              value: "attributables.INDX",
            },
            {
              label: this.getDictionary(
                "attribute_CONV_value",
                "insurance_policy"
              ),
              value: "attributables.CONV",
            },
            {
              label: this.getDictionary(
                "attribute_LNOT_value",
                "insurance_policy"
              ),
              value: "attributables.LNOT",
            },
            {
              label: this.getDictionary(
                "attribute_BONA_value",
                "insurance_policy"
              ),
              value: "attributables.BONA",
            },
            {
              label: this.getDictionary("delay_days", "insurance_policy"),
              value: "delay_days",
            },
          ],
        },
        stato_policy: {
          header: "Stato polizza",
          edit: false,
          repository: "insurance_policy",
          shortcut: canVerb("insurance_policies", "edit")
            ? {
                label: "Modifica",
                click: () => this.onModifica(),
              }
            : {},
          fields: [
            {
              label: this.getDictionary("status_policy", "insurance_policy"),
              value: "status_policy.text",
            },
            {
              label: this.getDictionary("old_policy", "insurance_policy"),
              value: "number",
              virtual: "OLD_POLICY",
              relation: "old_policy",
              isLink: true,
            },
            {
              label: this.getDictionary("new_policies", "insurance_policy"),
              value: "number",
              // extra: {
              //   type: "Array",
              //   value: "number"
              // },
              virtual: "NEW_POLICIES",
              relation: "new_policies",
              isLink: true,
            },
          ],
        },
        // status_registry_1: {
        //   dati_anagrafici: {
        //     header: "Dati Anagrafici del contraente",
        //     edit: false,
        //     repository: "registry",
        //     fields: [
        //       {
        //         label: this.getDictionary("status_registry", "registry"),
        //         option: "status_registry",
        //         value: "registry.status_registry.text",
        //       },
        //       {
        //         label: this.getDictionary("attribute_CNAM_value", "registry"),
        //         value: "registry.attributables.CNAM",
        //       },
        //       {
        //         label: this.getDictionary("attribute_CREG_value", "registry"),
        //         value: "registry.attributables.CREG",
        //       },
        //     ],
        //   },
        // },
        // status_registry_0: {
        //   dati_anagrafici: {
        //     header: "Dati Anagrafici del contraente",
        //     edit: false,
        //     repository: "registry",
        //     fields: [
        //       {
        //         label: this.getDictionary("status_registry", "registry"),
        //         option: "status_registry",
        //         value: "registry.status_registry.text",
        //       },
        //       {
        //         label: this.getDictionary("attribute_TITL_value", "registry"),
        //         value: "registry.attributables.TITL",
        //       },
        //       {
        //         label: this.getDictionary("attribute_NAME_value", "registry"),
        //         value: "registry.attributables.NAME",
        //       },
        //       {
        //         label: this.getDictionary("attribute_SURN_value", "registry"),
        //         value: "registry.attributables.SURN",
        //       },
        //       {
        //         label: this.getDictionary("attribute_NINO_value", "registry"),
        //         value: "registry.attributables.NINO",
        //       },
        //       {
        //         label: this.getDictionary("attribute_MARS_value", "registry"),
        //         value: "registry.attributables.MARS",
        //       },
        //       {
        //         label: this.getDictionary("attribute_PROF_value", "registry"),
        //         value: "registry.attributables.PROF",
        //       },
        //       {
        //         label: this.getDictionary("attribute_DOB_value", "registry"),
        //         value: "registry.attributables.DOB",
        //       },
        //       {
        //         label: this.getDictionary("attribute_POB_value", "registry"),
        //         value: "registry.attributables.POB",
        //       },
        //       {
        //         label: `${this.getDictionary("province")} nascita`,
        //         value: "registry.attributables.POB",
        //         virtual: "PROVINCE",
        //       },
        //       {
        //         label: this.getDictionary("country"),
        //         value: "registry.attributables.POB",
        //         virtual: "NATION",
        //       },
        //       {
        //         label: this.getDictionary("attribute_ISPL_value", "registry"),
        //         value: "registry.attributables.ISPL",
        //       },
        //       {
        //         label: `${this.getDictionary("province")} emissione`,
        //         value: "registry.attributables.ISPL",
        //         virtual: "PROVINCE",
        //       },
        //       {
        //         label: this.getDictionary("attribute_SEX_value", "registry"),
        //         value: "registry.attributables.SEX",
        //       },
        //     ],
        //   },
        // },
        // nascita: {
        //   header: "Nato a:",
        //   repository: "registry",
        //   edit: false,
        //   fields: [
        //     {
        //       label: this.getDictionary("attribute_POB_value", "registry"),
        //       value: "registry.attributables.POB",
        //     },
        //     {
        //       label: this.getDictionary("province"),
        //       value: "registry.attributables.POB",
        //       virtual: "PROVINCE",
        //     },
        //     {
        //       label: this.getDictionary("attribute_NOB_value", "registry"),
        //       value: "registry.attributables.POB",
        //       virtual: "NATION",
        //     },
        //     {
        //       label: this.getDictionary("attribute_DOB_value", "registry"),
        //       value: "registry.attributables.DOB",
        //     },
        //     {
        //       label: this.getDictionary("attribute_NOB2_value", "registry"),
        //       value: "registry.attributables.NOB",
        //       virtual: "NATION2",
        //     },
        //     {
        //       label: this.getDictionary("attribute_POB2_value", "registry"),
        //       value: "registry.attributables.POB2",
        //     },
        //   ],
        // },
        // residenza: {
        //   header: "Residenza / Sede Legale",
        //   repository: "correspondence",
        //   edit: false,
        //   fields: [
        //     {
        //       label: this.getDictionary(
        //         "attribute_NAME2_value",
        //         "correspondence"
        //       ),
        //       value: "",
        //       virtual: (detail) => {
        //         let alternativeAddress;
        //         let registryFullName;
        //         if (detail.registry) {
        //           const found = detail.registry.correspondences.find(
        //             (correspondence) =>
        //               correspondence.status_correspondence.value === 0
        //           );
        //           if (found) {
        //             alternativeAddress = found.attributables.NAME2;
        //             registryFullName = detail.registry.title;
        //           }
        //         }
        //         return alternativeAddress
        //           ? alternativeAddress
        //           : registryFullName;
        //       },
        //     },
        //     {
        //       label: this.getDictionary(
        //         "attribute_ADDR_value",
        //         "correspondence"
        //       ),
        //       value: "attributables.ADDR",
        //       relation: "registry.correspondences",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //     {
        //       label: this.getDictionary(
        //         "attribute_CITY_value",
        //         "correspondence"
        //       ),
        //       value: "attributables.CITY",
        //       relation: "registry.correspondences",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //     {
        //       label: this.getDictionary(
        //         "attribute_CITY2_value",
        //         "correspondence"
        //       ),
        //       value: "attributables.CITY2",
        //       relation: "correspondences",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //     {
        //       label: this.getDictionary("province"),
        //       value: "attributables.CITY",
        //       relation: "registry.correspondences",
        //       virtual: "PROVINCE",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //     {
        //       label: this.getDictionary(
        //         "attribute_ZIPC_value",
        //         "correspondence"
        //       ),
        //       value: "attributables.ZIPC",
        //       relation: "registry.correspondences",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //     {
        //       label: this.getDictionary(
        //         "attribute_NOR_value",
        //         "correspondence"
        //       ),
        //       value: "attributables.CITY",
        //       virtual: "NATION",
        //       relation: "registry.correspondences",
        //       status: 0,
        //     },
        //     {
        //       label: `${this.getDictionary(
        //         "attribute_NOR_value",
        //         "correspondence"
        //       )} estera`,
        //       value: "attributables.NOR",
        //       relation: "registry.correspondences",
        //       status: 0, // Residenza / Sede Legale
        //     },
        //   ],
        // },
      },
      detailFields2: {
        status_registry_1: {
          dati_anagrafici: {
            header: "Dati Anagrafici del contraente",
            edit: false,
            repository: "registry",
            fields: [
              {
                label: this.getDictionary("status_registry", "registry"),
                option: "status_registry",
                value: "registry.status_registry.text",
              },
              {
                label: this.getDictionary("attribute_CNAM_value", "registry"),
                value: "registry.attributables.CNAM",
              },
              {
                label: this.getDictionary("attribute_CREG_value", "registry"),
                value: "registry.attributables.CREG",
              },
            ],
          },
        },
        status_registry_0: {
          dati_anagrafici: {
            header: "Dati Anagrafici del contraente",
            edit: false,
            repository: "registry",
            fields: [
              {
                label: this.getDictionary("status_registry", "registry"),
                option: "status_registry",
                value: "registry.status_registry.text",
              },
              {
                label: this.getDictionary("attribute_TITL_value", "registry"),
                value: "registry.attributables.TITL",
              },
              {
                label: this.getDictionary("attribute_NAME_value", "registry"),
                value: "registry.attributables.NAME",
              },
              {
                label: this.getDictionary("attribute_SURN_value", "registry"),
                value: "registry.attributables.SURN",
              },
              {
                label: this.getDictionary("attribute_NINO_value", "registry"),
                value: "registry.attributables.NINO",
              },
              {
                label: this.getDictionary("attribute_MARS_value", "registry"),
                value: "registry.attributables.MARS",
              },
              {
                label: this.getDictionary("attribute_PROF_value", "registry"),
                value: "registry.attributables.PROF",
              },
              {
                label: this.getDictionary("attribute_DOB_value", "registry"),
                value: "registry.attributables.DOB",
              },
              {
                label: this.getDictionary("attribute_POB_value", "registry"),
                value: "registry.attributables.POB",
              },
              {
                label: `${this.getDictionary("province")} nascita`,
                value: "registry.attributables.POB",
                virtual: "PROVINCE",
              },
              {
                label: this.getDictionary("country"),
                value: "registry.attributables.POB",
                virtual: "NATION",
              },
              {
                label: this.getDictionary("attribute_ISPL_value", "registry"),
                value: "registry.attributables.ISPL",
              },
              {
                label: `${this.getDictionary("province")} emissione`,
                value: "registry.attributables.ISPL",
                virtual: "PROVINCE",
              },
              {
                label: this.getDictionary("attribute_SEX_value", "registry"),
                value: "registry.attributables.SEX",
              },
            ],
          },
        },
        nascita: {
          header: "Nato a",
          repository: "registry",
          edit: false,
          fields: [
            {
              label: this.getDictionary("attribute_POB_value", "registry"),
              value: "registry.attributables.POB",
            },
            {
              label: this.getDictionary("province"),
              value: "registry.attributables.POB",
              virtual: "PROVINCE",
            },
            {
              label: this.getDictionary("attribute_NOB_value", "registry"),
              value: "registry.attributables.POB",
              virtual: "NATION",
            },
            {
              label: this.getDictionary("attribute_DOB_value", "registry"),
              value: "registry.attributables.DOB",
            },
            {
              label: this.getDictionary("attribute_NOB2_value", "registry"),
              value: "registry.attributables.NOB",
              virtual: "NATION2",
            },
            {
              label: this.getDictionary("attribute_POB2_value", "registry"),
              value: "registry.attributables.POB2",
            },
          ],
        },
        residenza: {
          header: "Residenza / Sede Legale",
          repository: "correspondence",
          edit: false,
          fields: [
            {
              label: this.getDictionary(
                "attribute_NAME2_value",
                "correspondence"
              ),
              value: "",
              virtual: (detail) => {
                let alternativeAddress;
                let registryFullName;
                if (detail.registry) {
                  const found = detail.registry.correspondences.find(
                    (correspondence) =>
                      correspondence.status_correspondence.value === 0
                  );
                  if (found) {
                    alternativeAddress = found.attributables.NAME2;
                    registryFullName = detail.registry.title;
                  }
                }
                return alternativeAddress
                  ? alternativeAddress
                  : registryFullName;
              },
            },
            {
              label: this.getDictionary(
                "attribute_ADDR_value",
                "correspondence"
              ),
              value: "attributables.ADDR",
              relation: "registry.correspondences",
              status: 0, // Residenza / Sede Legale
            },
            {
              label: this.getDictionary(
                "attribute_CITY_value",
                "correspondence"
              ),
              value: "attributables.CITY",
              relation: "registry.correspondences",
              status: 0, // Residenza / Sede Legale
            },
            {
              label: this.getDictionary(
                "attribute_CITY2_value",
                "correspondence"
              ),
              value: "attributables.CITY2",
              relation: "correspondences",
              status: 0, // Residenza / Sede Legale
            },
            {
              label: this.getDictionary("province"),
              value: "attributables.CITY",
              relation: "registry.correspondences",
              virtual: "PROVINCE",
              status: 0, // Residenza / Sede Legale
            },
            {
              label: this.getDictionary(
                "attribute_ZIPC_value",
                "correspondence"
              ),
              value: "attributables.ZIPC",
              relation: "registry.correspondences",
              status: 0, // Residenza / Sede Legale
            },
            {
              label: this.getDictionary(
                "attribute_NOR_value",
                "correspondence"
              ),
              value: "attributables.CITY",
              virtual: "NATION",
              relation: "registry.correspondences",
              status: 0,
            },
            {
              label: `${this.getDictionary(
                "attribute_NOR_value",
                "correspondence"
              )} estera`,
              value: "attributables.NOR",
              relation: "registry.correspondences",
              status: 0, // Residenza / Sede Legale
            },
          ],
        },
      },
      // coassFields: {
      //   coass: {
      //     header: "Coassicurazioni",
      //     edit: false,
      //     repository: "insurer_participant",
      //     // "id": 1,
      //     // "title": "RSC1",
      //     // "code": "CA1",
      //     // "title_importer": "CR1",
      //     // "code_importer": "CC1",
      //     // "formatted_title": "RSC1",
      //     // "last_update": "2023-03-08 17:47:17",
      //     // "last_delete": null,
      //     // "pivot": {
      //     //     "insurance_policy_id": 21,
      //     //     "insurer_participant_id": 1,
      //     //     "share": "80.00"
      //     // },
      //     fields: [
      //       {
      //         label: this.getDictionary(
      //           "Nostra quota per coass delega Nostra",
      //           "insurer_participant"
      //         ),
      //         value: "insurance_policy.sharing",
      //         type: "currency",
      //       },

      //       // cc1 - cr1 compa delegata
      //       // code - age delegate
      //     ],
      //   },
      // },
      coassDetailFields: [
        {key: "compagnia_delegata", label: "Compagnia delegata"},
        {key: "agenzie_delegate", label: "Agenzia delegata"},
        {
          key: "quote_attribuite",
          label: "Quote attribuite",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
      coassDetails: [],
    };
  },
  methods: {
    toInfoData,
    getRiskTypeDescription,
    canVerb,
    setTab(tab, index) {
      console.log("template.vue - select tab: ", tab.name);
      this.selTab = tab.name;
      this.tabIndex = index;
    },
    onModalShow() {
      if (this.tabIndex < this.tabs.length)
        this.setTab(this.tabs[this.tabIndex], this.tabIndex);
    },
    onModalHidden() {
      this.setTab({name: "General", text: "Generale"}, 0);
    },
    evaluateBroker(detail) {
      const broker_info = Object.prototype.hasOwnProperty.call(detail, "broker")
        ? this.toInfoData(detail.broker, "broker", null, " ")
        : "";
      const broker_updated =
        Object.prototype.hasOwnProperty.call(detail, "broker_updated") &&
        detail.broker_updated === 1
          ? "<span class='icon icon--pencil'></span>"
          : "";
      return `${broker_info}${broker_updated}`;
    },
    onSostituisci() {
      this.$router.push({
        name: "insurance_policies.replace",
        params: {
          id: `${this.resourceId}`,
          data: {
            details: this.fetchedDetails,
            beForm: this.beForm,
          },
          fromTab: this.$options.name,
        },
      });
    },
    onVoltura() {
      this.$router.push({
        name: "insurance_policies.transfer",
        params: {
          id: `${this.resourceId}`,
          fromTab: this.$options.name,
        },
      });
    },
    onModifica() {
      const targetId = `${this.resourceId}`;
      // se siamo già sulla pagina di modifica di questa polizza, evito la
      // navigazione ridondante (NavigationDuplicated)
      if (
        this.$route.name === "insurance_policies.edit" &&
        `${this.$route.params.id}` === targetId
      ) {
        return;
      }
      this.$router
        .push({
          name: "insurance_policies.edit",
          params: {
            id: targetId,
            item: this.details,
            fromTab: this.$options.name,
          },
        })
        .catch((err) => {
          // ignoro l'eventuale NavigationDuplicated, rilancio gli altri errori
          if (err?.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },
    fetch() {
      let filter = `relations/byBroker/byCollaborator/byRegistry/byInsurer/byInsurerParticipant/byInsuranceRisk/byNewPolicy/byOldPolicy`;
      let queryString = `${filter ? filter : ""}`;
      this.fetchShowForm(this.repository, this.resourceId, queryString)
        .then((response) => {
          const data = response.data.data;
          this.status_registry_value = data.registry?.status_registry.value;
          // this.status_coass = data.insurer_participants?.length;
          if (data.insurer_participants?.length) {
            this.$set(this, "coassDetails", data.insurer_participants);
          }
          this.details = data;
          this.fetchedDetails = data;

          this.repositoryResourceId.registry.id = data.registry?.id;
          // #715
          // se la polizza è a mano ed è in stato perfezionata (1) o sospesa (2),
          // compare il tasto “sostituisci”
          // isImported
          // let isImported = true;
          if (this.details.insurer) {
            this.isImported = this.details.insurer.importer_id !== null;

            if (this.isImported && this.details.insurer.import_override === 1) {
              this.isImported = false;
            }
            this.statusPolicyValue = this.details.status_policy.value;
          }
          // if (
          //   this.canVerb("insurance_policies", "store") &&
          //   !this.isImported &&
          //   [1, 2].includes(this.details.status_policy.value)
          // ) {
          //   let s = {
          //     label: "Sostituisci",
          //     click: () => {
          //       this.shortcut(
          //         "insurance_policies.replace",
          //         this.resourceId,
          //         null,
          //         null,
          //         null,
          //         null,
          //         null,
          //         { details: this.details, beForm: this.beForm },
          //         this.$options.name
          //       );
          //     },
          //   };
          //   this.$set(this.detailFields1.dati_identificativi, "shortcut", s);
          // }
          this.isLoading = false;
          this.$emit("number", data.number);
        })
        .catch((error) => {
          this.form = {};
          console.error(error);
        })
        .finally(() => {
        });
    },
    onOpenDetailsModal(id, caption) {
      console.debug(`onOpenDetailsModal id: ${id} - ${caption}`);
      this.modalResourceId = id;
      this.modalResourceTitle = caption;
      // this.$bvModal.show("detailsModal");
      this.$bvModal.show("modal");
    },
    ...mapGetters("auth", {
      getMandateCodes: "mandate_codes",
    }),
  },
  computed: {
    selTab: {
      set(value) {
        this.selected = value;
      },
      get() {
        return this.selected;
      },
    },
    dtlFlds1() {
      return this.detailFields1;
    },
    dtlFlds2() {
      // mergia i campi di status 0 o 1 con quelli in comune
      let {status_registry_0, status_registry_1, ...rest} =
        this.detailFields2;
      let reg = this.status_registry_value
        ? status_registry_1
        : status_registry_0;
      let r = {...reg, ...rest};
      // let coa = this.status_coass ? coass : null;
      // let r;
      // if (coa) {
      //   r = { ...rest, coa, ...reg, nascita, residenza };
      // } else {
      //   r = { ...rest, ...reg, nascita, residenza };
      // }
      return r;
    },
    computeModalTitle() {
      return `Dettagli - Numero Polizza: ${this.modalResourceTitle}`;
    },
  },
  mounted() {
    this.isLoading = true;
    this.$emit("number", "");
    this.fetch();
  },
};
</script>

<style lang="scss">
.policies-top-actions {
  &:not(:has(.btn)) {
    display: none !important;
  }
}
</style>
